import { PossiblyNamedModelEntityReference } from '@upright/common/model/input/types';
import { useOpenSubscriptionModal } from '@upright/ui/common/activities/company-subscription/subscription-modal/use-open-subscription-modal';
import { getBouLinkStyle } from '@upright/ui/common/generic/content/texts/bou-link';
import styled from 'styled-components';
import { BoxCta } from '../common/box-cta';

interface Props {
  company?: PossiblyNamedModelEntityReference;
}

export function EmptyStateStartManagingCompanyCTA(props: Props) {
  const openSubscriptionModal = useOpenSubscriptionModal();
  return (
    <BoxCta title="Manage this company">
      <p>
        <StyledTextButton
          onClick={() => {
            openSubscriptionModal({ companyId: props.company?.id, companyName: props.company?.name });
          }}
        >
          Sign up
        </StyledTextButton>{' '}
        for free to get preliminary impact data for your company.
      </p>
    </BoxCta>
  );
}

const StyledTextButton = styled.button`
  ${getBouLinkStyle(true)};
`;
